import "./Activities.css";

import { AssetManagerSingleCardTemplate } from "../../../templates";
import { ChartsSection } from "../../../templates/components";
import { Column, CursorDataGrid, Row } from "../../../widget";
import { useActivities } from "./useActivities";

const Activities = (): JSX.Element => {
  const {
    activityTypeChartData,
    activityStatusChartData,
    activityCodeChartData,
    activityDeveloperChartData,
    columns,
    isLoading,
    defaultSortingCriteria,
    onChange,
  } = useActivities();

  return (
    <AssetManagerSingleCardTemplate activeElement="Portfolio" pageTitle="Activities">
      <div className="Activities">
        <Row spacingV="ll">
          <Column span={12}>
            <ChartsSection
              title="At a glance"
              firstChartData={activityTypeChartData}
              firstChartTitle="Type"
              secondChartData={activityStatusChartData}
              secondChartTitle="Status"
              thirdChartData={activityCodeChartData}
              thirdChartTitle="Code"
              fourthChartData={activityDeveloperChartData}
              fourthChartTitle="Developer"
              isGradient
              direction="Vertical"
            />
          </Column>
        </Row>
        <div className="ActivitiesTable">
          <Row spacingV="m">
            <Column span={12}>
              <h2>Activities</h2>
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              <CursorDataGrid
                columns={columns}
                clientSide={false}
                filterable
                onChange={onChange}
                data={[]}
                dataIsLoading={isLoading}
                noDataMessage="No activities to display"
                defaultSortingCriteria={defaultSortingCriteria}
                variant="seed"
              />
            </Column>
          </Row>
        </div>
      </div>
    </AssetManagerSingleCardTemplate>
  );
};

export default Activities;
